module.exports = __webpack_public_path__ + "static/glosy_radiowego_teatru-6a29e87d7c4ea285dd793535fa741477.jpg";